import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Dialog } from '../../../base/dialog';
import { toggleVisitorsMode } from '../../actions';
import { VISITOR_MODE_MOVE_CURRENT_GUESTS, VISITOR_MODE_NEW_GUESTS_ONLY } from '../../constants';
/**
 * Confirmation dialog shown to a moderator when turning visitor mode on. Lets the moderator choose
 * whether visitor mode applies only to new guests or also moves existing guests into visitor mode.
 *
 * @returns {JSX.Element}
 */
const EnableVisitorsDialog = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [mode, setMode] = useState(VISITOR_MODE_NEW_GUESTS_ONLY);
    const onSubmit = useCallback(() => {
        dispatch(toggleVisitorsMode(true, mode, mode === VISITOR_MODE_MOVE_CURRENT_GUESTS));
        // Returning true tells the dialog to close.
        return true;
    }, [dispatch, mode]);
    const options = [
        {
            value: VISITOR_MODE_NEW_GUESTS_ONLY,
            titleKey: 'visitors.enableDialog.newGuestsTitle',
            descriptionKey: 'visitors.enableDialog.newGuestsDescription'
        },
        {
            value: VISITOR_MODE_MOVE_CURRENT_GUESTS,
            titleKey: 'visitors.enableDialog.moveCurrentTitle',
            descriptionKey: 'visitors.enableDialog.moveCurrentDescription'
        }
    ];
    return (React.createElement(Dialog, { okKey: 'visitors.enableDialog.enable', onSubmit: onSubmit, titleKey: 'visitors.enableDialog.title', width: 'small' },
        React.createElement("div", { id: 'enable-visitors-dialog' },
            React.createElement("div", { className: 'description' }, t('visitors.enableDialog.description')),
            options.map(option => (React.createElement("label", { className: `visitor-mode-option${mode === option.value ? ' selected' : ''}`, key: option.value },
                React.createElement("input", { checked: mode === option.value, name: 'visitor-mode', onChange: () => setMode(option.value), type: 'radio', value: option.value }),
                React.createElement("div", { className: 'option-text' },
                    React.createElement("span", { className: 'option-title' }, t(option.titleKey)),
                    React.createElement("span", { className: 'option-description' }, t(option.descriptionKey)))))))));
};
export default EnableVisitorsDialog;
